import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import API from '../../api/API';

/**
 * La scorciatoia /qr/foto, quella stampata sui QR code, deve aprire l'album della nazionale in
 * corso. L'id dell'album pero' non si puo' cablare come si fa per planning e statistiche: li' il
 * numero e' l'edizione, che esiste da mesi quando i codici vanno in stampa, qui e' l'album, che
 * nasce solo quando qualcuno lo crea dal pannello. Quindi si parte dall'edizione e l'album lo si
 * chiede: finche' non c'e' si finisce in galleria, e il codice comincia a funzionare da solo il
 * giorno che l'album viene creato.
 */
export default function RedirectFotoEdizione({ idEdizione }) {
  const [destinazione, setDestinazione] = useState(null);

  useEffect(() => {
    let vivo = true;
    const arriva = (dove) => { if (vivo) setDestinazione(dove); };

    API.foto.edizione(idEdizione)
      .then(r => {
        const album = r?.isSuccess && Array.isArray(r.data) ? r.data : [];
        // Un'edizione non dovrebbe avere piu' di un album, ma se ne ha si apre l'ultimo creato.
        const ultimo = album.reduce((max, a) => (max === null || a.id > max.id ? a : max), null);
        arriva(ultimo ? `/foto/${ultimo.id}` : '/foto');
      })
      .catch(() => arriva('/foto'));

    return () => { vivo = false; };
  }, [idEdizione]);

  if (destinazione === null) return null;

  return <Navigate to={destinazione} replace />;
}
